import { useAppSelector } from 'state/hooks';
import {
  selectCurrentProjectInfo,
  selectRouteSelection,
} from 'state/workflowSlice';

import { useTargetDateMetrics } from 'features/workflow_traveltime/nrtTravelTimeCommon';

import {
  capitalizeFirstLetter,
  formatDistance,
  formatTraveltime,
} from '../utils';
import { useRouteInfo } from './useRouteInfo';
import { useSegmentProperties } from './useSegmentProperties';

/** Route properties take precedence; if unavailable (for unsaved routes/segments), fall back to segment properties. */
export const useRouteProperties = () => {
  const routeSelection = useAppSelector(selectRouteSelection);
  const userProject = useAppSelector(selectCurrentProjectInfo);

  const { feature, savedRoute } = useRouteInfo();
  const segmentProperties = useSegmentProperties();
  // ttData from REST api
  const { metrics } = useTargetDateMetrics();

  if (!userProject || !segmentProperties) return null;

  const routeProperties = feature?.properties;

  const { name, freeflowSpeed, segment, cardinalDirection } = segmentProperties;

  return {
    routeSelection,
    routeLength: routeProperties?.route_length
      ? formatDistance(routeProperties?.route_length, userProject.uses_metric)
      : undefined,
    freeflowTraveltime: metrics?.freeflow_traveltime
      ? formatTraveltime(metrics.freeflow_traveltime)
      : undefined,
    cardinalDirection: routeProperties?.cardinal_direction
      ? capitalizeFirstLetter(routeProperties?.cardinal_direction)
      : cardinalDirection,
    name: savedRoute ? savedRoute.routeName : name,
    freeflowSpeed,
    segment,
    isSaved: !!savedRoute,
  };
};
